import { colors } from "@/app/Colors";
import { FaceBookIcon, InstagramIcon, YoutubeFill } from "@/utlility/icons";


export const usefulLinks = [
  {
    category_name: "Home",
    category_slug: "/",
  },
  {
    category_name: "About",
    category_slug: "/about-us",
  },
  {
    category_name: "Our Services",
    category_slug: "/all-treatments",
  },
  {
    category_name: "Blog",
    category_slug: "/blog",
  },
  {
    category_name: "Gallery",
    category_slug: "/gallery",
  },

]


export const socialIcons = [
  {
    name: "Facebook",
    icon: <FaceBookIcon color={colors["--icon"]} size={20} />,
    link: "https://www.facebook.com/",
  },
  {
    name: "Instagram",
    icon: <InstagramIcon color={colors["--icon"]} size={20} />,
    link: "https://www.instagram.com/",
  },
  {
    name: "Youtube",
    icon: <YoutubeFill color={colors["--icon"]} size={20} />,
    link: "https://www.youtube.com/@drkenillathia3870",
  },
];
export const FootersocialIcons = [
  {
    name: "Facebook",
    icon: <FaceBookIcon size={18} />,
    link: "#",
  },
  {
    name: "Instagram",
    icon: <InstagramIcon size={18} />,
    link: "#",
  },
  {
    name: "Youtube",
    icon: <YoutubeFill size={18} />,
    link: "#",
  },
];
export const topHeaderLinks = [
  {
    name: "Home",
    href: "/"
  },
  {
    name: "About Us",
    href: "/about-us"
  },
  {
    name: "Blog",
    href: "/blog"
  },
  {
    name: "Gallery",
    href: "/gallery",
    subLinks: [
      { name: "Images", tab: "image" },
      { name: "Videos", tab: "video" }
    ]
  },
  {
    name: "Contact Us",
    href: "/contact-us"
  },

]